import React, { useState } from "react";
import Cookies from 'js-cookie';

// Style //
import "./LogIn.css";

// Images //
import { images } from "../../../assets/index";

// Components //
import { FormInput, ButtonComp, Loader } from "../../../common/components/index";
import {toast} from "react-toastify"

// Actions //
import { loginUser } from "../../../redux/actions/authAction";
import {
  receivedError,
  requestSent,
  responseRecived,
} from "../../../redux/actions/utilsActions";

// Hooks //
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// API's //
import { logInApi } from "../../../api/authApi";

const Login = () => {
  // Hooks //
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [rememberMe, setSememberMe] = useState(false);
  const navigate = useNavigate()

  // Utils //
  const { error, loading } = useSelector((state) => state.utils);

  const dispatch = useDispatch();

  // API Calls //
  const loginApiCall = async () => {
    try {
      const userDetails = {
        email: userEmail,
        password: userPassword,
      };
      dispatch(requestSent());

      // Login Api Call //
      const data = await logInApi(userDetails);
      dispatch(loginUser(data, rememberMe));
      // ========================//
      if(rememberMe){
        localStorage.setItem("userData", JSON.stringify(data))
      }else{
        // sessionStorage.setItem("userData", JSON.stringify(data))
        Cookies.set("userData", JSON.stringify(data));
      }
      // ========================//

      setUserEmail("");
      setUserPassword("");

      dispatch(responseRecived());

      navigate("/")
    } catch (error) {
      console.log("Login Page error::", error);
      dispatch(receivedError(error));
      dispatch(responseRecived());
    }
  };

  // Hendler //
  const loginHendler = async () => {
    if (!userEmail || !userPassword) {
      alert("Please Fill all Field");
      return;
    }
    loginApiCall();
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      loginHendler();
    }
  };

  return (
    <div className="login_wraper">
      {loading ? <Loader /> : ""}
      <div className="login_form">
        <div className="header">
          <img src={images.subbyLogo} alt="" />
          <h2>LogIn</h2>
        </div>
        <div className="inp_fields_cont">
          <FormInput
            lable={"Email"}
            type={"text"}
            placeholder={"Enter Registered Email"}
            width={"100%"}
            onchange={(email) => setUserEmail(email)}
            value={userEmail}
            error={error?.data}
            onKeyPress={handleKeyPress}
          />
          <FormInput
            lable={"Password"}
            type={"password"}
            placeholder={"Enter Your Password"}
            width={"100%"}
            onchange={(pass) => setUserPassword(pass)}
            value={userPassword}
            error={error?.data}
            onKeyPress={handleKeyPress}
          />
          {error? (<p className="err_message">*{error?.data?.error_message}</p>): ""}
          <div className="remembreme_forgote_pass">
            <div className="check_box_cont">
              <input type="checkbox" id="remember-me" onChange={()=>setSememberMe(!rememberMe)}/>
              <label htmlFor="remember-me">Remember Me</label>
            </div>
            <p onClick={()=>navigate("/send-mail")}>FORGOTTEN PASSWORD</p>
          </div>
          <ButtonComp title={"Log In"} width={"100%"} onClick={loginHendler} />
          <p className="contact_us">
            Don't have an account? <span>Contact us</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
